if (!customElements.get('csb-steel-hero-loop')) {
 customElements.define('csb-steel-hero-loop', class extends HTMLElement {
  connectedCallback() {
   if(this.bound)return;this.bound=true;
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');
   this.mobileMotion=matchMedia('(max-width: 749px), (pointer: coarse)');
   this.chapters = Array.from(this.querySelectorAll('[data-chapter]'));
   this.chapterLabels = this.chapters.map(chapter => chapter.querySelector('h1,h2')?.textContent.replace(/\s+/g,' ').trim() || '');
   this.cards = [this.querySelector('[data-part="card-a"]'),this.querySelector('[data-part="card-b"]')];
   this.pen = this.querySelector('[data-part="pen"]');
   this.notes = Array.from(this.querySelectorAll('[data-note]'));
   this.assembly = this.querySelector('.csb-stage__assembly');
   this.frame = this.querySelector('.csb-stage__frame');
   this.pin = this.querySelector('.csb-stage__pin');
   this.engraving = this.querySelector('[data-engraving]');
   this.letters = Array.from(this.querySelectorAll('[data-etch-letter]')).map((group,index)=>({group,index,glyph:group.dataset.sourceLetter,word:Number(group.dataset.wordIndex),column:Number(group.dataset.letterIndex),x:Number(group.dataset.x),y:Number(group.dataset.y),sourceX:Number(group.dataset.sourceX),sourceY:Number(group.dataset.sourceY),rotation:Number(group.dataset.rotation),inkBounds:[Number(group.dataset.inkLeft),Number(group.dataset.inkTop),Number(group.dataset.inkRight),Number(group.dataset.inkBottom)]}));
   this.strokes = Array.from(this.querySelectorAll('[data-etch-stroke]')).map((group,i) => {
    const line = group.querySelector('.csb-etch__line');
    const length = line.getTotalLength(), x = Number(group.dataset.x), y = Number(group.dataset.y);
    const first = line.getPointAtLength(0), last = line.getPointAtLength(length);
    return {group,line,length,x,y,index:i,word:Number(group.dataset.wordIndex),letter:Number(group.dataset.letterIndex),sequence:Number(group.dataset.letterSequence),paths:Array.from(group.querySelectorAll('path')),first:{x:first.x+x,y:first.y+y},last:{x:last.x+x,y:last.y+y}};
   });
   this.letters.forEach(letter=>{letter.strokes=this.strokes.filter(stroke=>stroke.sequence===letter.index);});
   this.scheduleEngraving();
   this.words = Array.from(this.querySelectorAll('[data-etch-word]')).map((group,i) => ({label:group.dataset.etchWord,end:this.strokes.filter(stroke=>stroke.word===i).at(-1).end}));
   this.nickname = {label:this.querySelector('[data-etch-nickname]').dataset.etchNickname,end:this.strokes.filter(stroke=>stroke.word===-1).at(-1).end};
   this.engravingRows = [this.nickname,...this.words];
   this.dataset.wordsTotal = String(this.words.length);

   this.progress=0;this.elapsed=0;this.raf=0;this.enabled=true;this.playing=false;this.visible=false;this.paused=false;
   this.timeline=[[0,0],[.075,.28],[.15,.468],[.31,.572],[.355,.618],[.39,.642],[.90,.86],[1,1]];
   this.configure=()=>{this.measureCamera();this.draw();};
   this.onMotion=()=>{if(this.motion.matches){this.progress=0;this.draw();}this.sync();};
   this.onVisibility=()=>this.sync();
   this.onFrame=now=>{
    this.raf=0;if(!this.playing)return;
    const delta=this.lastFrame===null?0:Math.min(80,Math.max(0,now-this.lastFrame));this.lastFrame=now;
    this.elapsed=(this.elapsed+delta)%44000;
    const t=Math.min(1,this.elapsed/42000);let i=0;
    while(i<this.timeline.length-2&&t>this.timeline[i+1][0])i++;
    const a=this.timeline[i],b=this.timeline[i+1];this.progress=a[1]+(b[1]-a[1])*this.clamp((t-a[0])/(b[0]-a[0]));
    this.frame.style.opacity=String(this.elapsed>43000?(44000-this.elapsed)/1000:this.elapsed<500?this.elapsed/500:1);
    this.draw();this.raf=requestAnimationFrame(this.onFrame);
   };
   this.motion.addEventListener('change',this.onMotion);document.addEventListener('visibilitychange',this.onVisibility);
   this.configure();this.cameraObserver=new ResizeObserver(this.configure);this.cameraObserver.observe(this.pin);
   this.observer=new IntersectionObserver(entries=>{this.visible=entries.some(e=>e.isIntersecting);this.sync();},{threshold:0});this.observer.observe(this);
  }
  setPaused(paused){this.paused=paused;this.sync();}
  sync(){
   this.playing=this.visible&&!document.hidden&&!this.motion.matches&&!this.paused;
   cancelAnimationFrame(this.raf);this.raf=0;this.lastFrame=null;
   if(this.playing)this.raf=requestAnimationFrame(this.onFrame);
   else this.frame.style.opacity='1';
  }
  disconnectedCallback(){cancelAnimationFrame(this.raf);this.playing=false;this.motion?.removeEventListener('change',this.onMotion);document.removeEventListener('visibilitychange',this.onVisibility);this.cameraObserver?.disconnect();this.observer?.disconnect();this.bound=false;}
  clamp(t) {return Math.max(0,Math.min(1,t));}
  smooth(a,b,p) {const t=this.clamp((p-a)/(b-a));return t*t*(3-2*t);}
  scheduleEngraving() {
   const inkLetter=(letter,start,end)=>{
    const total=letter.strokes.reduce((sum,stroke)=>sum+Math.max(8,stroke.length),0)+Math.max(0,letter.strokes.length-1)*8;
    const unit=(end-start)/total;
    let cursor=start;
    letter.inkStart=start;
    letter.strokes.forEach((stroke,index)=>{
     if(index)cursor+=8*unit;
     stroke.start=cursor;cursor+=Math.max(8,stroke.length)*unit;stroke.end=cursor;
    });
    letter.strokes.at(-1).end=end;letter.inkEnd=end;
   };
   const scheduleLetters=(letters,start,end)=>{
   const weights=letters.map(letter=>{
    const previous=this.letters[letter.index-1],a=this.alignedGuidePose(previous,1),b=this.alignedGuidePose(letter,1);
    const distance=Math.hypot((b[0]-a[0])*1270,(b[1]-a[1])*1270);
    const alignment=55+Math.min(140,distance*.1)+(letter.rotation!==previous.rotation?65:0)+(letter.word!==previous.word?25:0);
    const ink=letter.strokes.reduce((sum,stroke)=>sum+Math.max(8,stroke.length),0);
    return {alignment,ink,gaps:Math.max(0,letter.strokes.length-1)*8};
   });
   const scale=(end-start)/weights.reduce((total,weight)=>total+weight.alignment+weight.ink+weight.gaps,0);
   let cursor=start;
   letters.forEach((letter,i)=>{
    letter.alignStart=cursor;
    cursor+=weights[i].alignment*scale;
    const finish=cursor+(weights[i].ink+weights[i].gaps)*scale;
    inkLetter(letter,cursor,finish);cursor=finish;
   });
   letters.at(-1).strokes.at(-1).end=end;letters.at(-1).inkEnd=end;
   };
   const nickname=this.letters.filter(letter=>letter.word===-1),recovery=this.letters.filter(letter=>letter.word>=0);
   nickname[0].alignStart=.28;
   inkLetter(nickname[0],.468,.498);
   scheduleLetters(nickname.slice(1),.503,.572);
   recovery[0].alignStart=.606;
   inkLetter(recovery[0],.618,.636);
   scheduleLetters(recovery.slice(1),.642,.86);
   this.strokes.forEach(stroke=>{stroke.group.dataset.start=String(stroke.start);stroke.group.dataset.end=String(stroke.end);});
   this.letters.forEach(letter=>{letter.group.dataset.alignStart=String(letter.alignStart);letter.group.dataset.inkStart=String(letter.inkStart);letter.group.dataset.inkEnd=String(letter.inkEnd);});
  }
  alignedGuidePose(letter,compact) {
   const angle=letter.rotation*Math.PI/180,c=Math.cos(angle),s=Math.sin(angle);
   const sourceX=letter.sourceX-911,sourceY=letter.sourceY-1071;
   const destinationX=letter.x+.035*1270*compact-911,destinationY=letter.y+.065*1270-1071;
   return [-.13+(destinationX-c*sourceX+s*sourceY)/1270/compact,(destinationY-s*sourceX-c*sourceY)/1270,letter.rotation];
  }
  guidePose(p,compact) {
   const first=this.alignedGuidePose(this.letters[0],compact);
   if(p<.465){this.publish('activeLetter','0');this.publish('guideLetter',this.letters[0].glyph);return this.pose([[0,.26,-.025,13],[.28,.56,-.015,5],[.465,...first]],p);}
   let index=0;
   while(index<this.letters.length-1&&p>=this.letters[index+1].alignStart)index++;
   const letter=this.letters[index],target=this.alignedGuidePose(letter,compact);
   this.publish('activeLetter',String(index));
   this.publish('guideLetter',letter.glyph);
   if(p>=.572&&p<.618){
    const lastNickname=this.alignedGuidePose(this.letters.filter(item=>item.word===-1).at(-1),compact);
    const firstRecovery=this.alignedGuidePose(this.letters.find(item=>item.word===0),compact);
    const aside=[.74/compact,.18,0];
    return this.pose([[.572,...lastNickname],[.584,...aside],[.606,...aside],[.618,...firstRecovery]],p);
   }
   if(p>.88)return this.pose([[.88,...this.alignedGuidePose(this.letters.at(-1),compact)],[1,.32,-.02,10]],p);
   if(index===0||p>=letter.inkStart)return target;
   const previous=this.alignedGuidePose(this.letters[index-1],compact),t=this.smooth(letter.alignStart,letter.inkStart,p);
   return previous.map((value,i)=>value+(target[i]-value)*t);
  }
  strokePoint(stroke,fraction) {
   if(fraction<=0)return stroke.first;
   if(fraction>=1)return stroke.last;
   const point=stroke.line.getPointAtLength(stroke.length*fraction);
   return {x:point.x+stroke.x,y:point.y+stroke.y};
  }
  publish(name,value) {if(this.dataset[name]!==value)this.dataset[name]=value;}
  layoutNickname(compact) {
   if(this.nicknameCompact===compact)return;
   this.nicknameCompact=compact;
   const shift=.035*1270*(1-compact);
   this.letters.filter(letter=>letter.word===-1).forEach(letter=>{
    letter.x=Number(letter.group.dataset.x)+shift;
    letter.inkBounds=['Left','Top','Right','Bottom'].map((edge,i)=>Number(letter.group.dataset['ink'+edge])+(i%2===0?shift:0));
    letter.strokes.forEach(stroke=>{
     stroke.x=Number(stroke.group.dataset.x)+shift;
     const first=stroke.line.getPointAtLength(0),last=stroke.line.getPointAtLength(stroke.length);
     stroke.first={x:first.x+stroke.x,y:first.y+stroke.y};stroke.last={x:last.x+stroke.x,y:last.y+stroke.y};
     stroke.group.setAttribute('transform',`translate(${stroke.x} ${stroke.y})`);
    });
   });
   this.cameraKey='';
  }
  measureCamera() {
   const pin=this.pin.getBoundingClientRect();
   this.small=pin.width<520;
   this.cameraFrame={left:16,right:pin.width-16,top:16,bottom:pin.height-16,originX:pin.width/2,originY:this.assembly.offsetTop};this.cameraKey='';
  }
  prepareCamera(h,compact) {
   const frame=this.cameraFrame,key=[h,compact,frame.left,frame.right,frame.top,frame.bottom,frame.originY].join(':');
   if(this.cameraKey===key)return;
   this.cameraKey=key;
   const width=frame.right-frame.left,height=Math.max(1,frame.bottom-frame.top);
   const cardHeight=this.small?Math.min(620,Math.max(440,height*1.6)):Math.min(900,Math.max(560,height*1.75));
   const scale=cardHeight/h;
   this.cameraPlans=this.engravingRows.map((word,index)=>{
    const letters=this.letters.filter(letter=>letter.word===index-1);
    const inkCenter=index===0?(Math.min(...letters.map(letter=>letter.inkBounds[0]))+Math.max(...letters.map(letter=>letter.inkBounds[2])))/2:685;
    const focusX=-.13*h*compact+(inkCenter+.035*1270*compact-911)*h/1270;
    const top=Math.min(...letters.map(letter=>letter.inkBounds[1]));
    const bottom=Math.max(...letters.map(letter=>letter.inkBounds[3]));
    const focusY=((top+bottom)/2+.065*1270-1071)*h/1270;
    return {scale,x:frame.left+width*(index===0?.5:.39)-frame.originX-focusX*scale,y:frame.top+height*.55-frame.originY-focusY*scale};
   });
  }
  applyCamera(p,h,compact) {
   const baseX=this.small?-46*this.smooth(.28,.44,p)*(1-this.smooth(.90,1,p)):-this.cameraFrame.originX*.16;
   const detail=this.smooth(.40,.468,p)*(1-this.smooth(.90,1,p));
   let camera={x:baseX,y:0,scale:1};
   if(detail>0){
    this.prepareCamera(h,compact);
    const letter=this.letters[Number(this.dataset.activeLetter)||0];
    let target=this.cameraPlans[letter.word+1];
    if(letter.word>=0&&letter.column===0&&p<letter.inkStart){
     const previous=this.cameraPlans[letter.word],t=this.smooth(letter.alignStart,letter.inkStart,p);
     target={x:previous.x+(target.x-previous.x)*t,y:previous.y+(target.y-previous.y)*t,scale:target.scale};
    }
    camera={x:baseX+(target.x-baseX)*detail,y:target.y*detail,scale:1+(target.scale-1)*detail};
   }
   this.assembly.style.transform=`translate(${camera.x}px,${camera.y}px) scale(${camera.scale})`;
   const top=this.cameraFrame.top,bottom=Math.max(0,this.pin.offsetHeight-this.cameraFrame.bottom);
   this.frame.style.clipPath=`inset(${top}px 0 ${bottom}px 0)`;
   this.frame.style.maskImage=`linear-gradient(to bottom,transparent ${top}px,#000 ${top+8}px,#000 calc(100% - ${bottom+8}px),transparent calc(100% - ${bottom}px))`;
   this.detail=detail;
   this.publish('cameraScale',camera.scale.toFixed(4));
   this.publish('cameraDetail',detail.toFixed(4));
  }
  applyMotionBlur(p,h,compact,pose,activeStroke) {
   const now=Date.now(),previous=this.lastMotion,scale=Number(this.dataset.cameraScale)||1;
   const allowed=this.enabled&&this.playing&&!this.motion.matches&&!this.mobileMotion.matches&&activeStroke<0&&p>.28&&p<1;
   if(allowed&&previous&&Math.abs(p-previous.p)>.00001){
    const distance=Math.hypot((pose[0]-previous.pose[0])*h*compact,(pose[1]-previous.pose[1])*h)+Math.abs(pose[2]-previous.pose[2])*Math.PI/180*h*.4;
    if(distance>.02){
     const speed=distance*scale/Math.max(16,now-previous.time);
     this.blurPeak=Math.min(5,speed*1.2);
     this.blurStarted=now;
    }
   }
   if(!allowed)this.blurPeak=0;
   const blur=(this.blurPeak||0)*(1-this.smooth(0,110,now-(this.blurStarted||0)));
   this.cards[1].style.setProperty('--csb-motion-blur',`${blur>.03?blur/scale:0}px`);
   this.publish('motionBlur',(blur>.03?blur:0).toFixed(3));
   this.lastMotion={p,pose:[...pose],time:now};
  }
  pose(frames,p) {
   let i=0;
   while(i<frames.length-2 && p>frames[i+1][0]) i++;
   const a=frames[i],b=frames[i+1],t=this.smooth(a[0],b[0],p);
   return a.slice(1).map((n,k)=>n+(b[k+1]-n)*t);
  }
  draw() {
   const p=this.enabled?this.clamp(this.progress):0;
   this.dataset.progress=p.toFixed(3);
   const bounds=[0,.20,.43,.89,1],active=p<.20?0:p<.43?1:p<.89?2:3;
   const enter=active===0?1:this.smooth(bounds[active],bounds[active]+.018,p);
   const leave=active===3?1:1-this.smooth(bounds[active+1]-.018,bounds[active+1],p);
   const weight=Math.min(enter,leave);
   this.dataset.chapter=active;
   this.chapters.forEach((el,i)=>{
    const shown=i===active;
    el.style.opacity=shown?weight.toFixed(3):'0';
    el.style.visibility=shown&&weight>.001?'visible':'hidden';
    el.style.transform=`translateY(${shown?(1-weight)*10*(enter<1?1:-1):0}px)`;
    el.setAttribute('aria-hidden',shown&&weight>.001?'false':'true');
   });
   const h=parseFloat(getComputedStyle(this.cards[0]).height),compact=this.small?.72:1;
   this.layoutNickname(compact);
   const cardA=this.pose([[0,-.21,.025,-14],[.28,-.56,0,-4],[.44,-.13,0,0],[.90,-.13,0,0],[1,-.32,.01,-10]],p);
   const cardB=this.guidePose(p,compact);
   this.cards.forEach((el,i)=>{const q=i?cardB:cardA;el.style.transform=`translate(-50%,-50%) translate(${q[0]*h*compact}px,${q[1]*h}px) rotate(${q[2]}deg)`;});
   this.cards[1].style.zIndex=p>.30?'4':'2';
   this.engraving.setAttribute('transform',`translate(${.035*1270*compact} ${.065*1270})`);
   let contact=this.strokes[0].first,drawn=0,activeStroke=-1,activeWord=0,liftProgress=0;
   this.strokes.forEach((stroke,i)=>{
    const fraction=this.smooth(stroke.start,stroke.end,p);
    drawn+=fraction;
    const shown=fraction.toFixed(5);
    if(stroke.shown!==shown){
     stroke.shown=shown;
     stroke.group.setAttribute('opacity',fraction>0?'1':'0');
     stroke.group.dataset.drawn=shown;
     stroke.paths.forEach(path=>path.style.strokeDashoffset=1-fraction);
    }
    if(p>=stroke.start){contact=this.strokePoint(stroke,fraction);activeWord=stroke.word;}
    if(p>=stroke.start&&p<stroke.end)activeStroke=i;
    const next=this.strokes[i+1];
    if(next&&p>stroke.end&&p<next.start){
     const t=this.smooth(stroke.end,next.start,p),from=stroke.last,to=next.first;
     const sameLetter=stroke.sequence===next.sequence,distance=Math.hypot(to.x-from.x,to.y-from.y);
     const lift=sameLetter?(distance<.05?0:Math.min(10,distance*.25)):110;
     contact={x:from.x+(to.x-from.x)*t,y:from.y+(to.y-from.y)*t-Math.sin(Math.PI*t)*lift};
     liftProgress=sameLetter?0:Math.sin(Math.PI*t);
    }
   });
   this.publish('engraved',(drawn/this.strokes.length).toFixed(3));
   this.publish('wordsComplete',String(this.words.filter(word=>p>=word.end).length));
   this.publish('nicknameComplete',String(p>=this.nickname.end));
   this.publish('nicknameReadable',String(p>=.584&&p<=.606));
   this.publish('engravingStage',p<this.strokes[0].start?'ready':p<=this.nickname.end?'nickname':p<.584?'nickname-lift':p<=.606?'nickname-reveal':p<.618?'transition':p<.86?'recovery':'complete');
   this.publish('activeWord',p>=this.strokes[0].start?(activeWord===-1?this.nickname.label:this.words[activeWord].label):'');
   this.publish('activeStroke',String(activeStroke));
   this.publish('penState',activeStroke>=0?'engraving':p>=.468&&p<.86?'raised':'rest');
   const writingAngle=76-4*liftProgress,angle=writingAngle*Math.PI/180,tipX=(249-226.5)*1.4/1800,tipY=(1886.35-1890)*1.4/1800;
   const rotatedTipX=tipX*Math.cos(angle)-tipY*Math.sin(angle),rotatedTipY=tipX*Math.sin(angle)+tipY*Math.cos(angle);
   const localX=(contact.x+.035*1270*compact-911)/1270,localY=(contact.y+.065*1270-1071)/1270;
   const cardAngle=cardA[2]*Math.PI/180;
   const contactX=cardA[0]+(localX*Math.cos(cardAngle)-localY*Math.sin(cardAngle)-rotatedTipX)/compact;
   const contactY=cardA[1]+localX*Math.sin(cardAngle)+localY*Math.cos(cardAngle)-rotatedTipY;
   const homeX=this.small?-.64/compact:.82,homeY=this.small?.57:.39,homeAngle=this.small?90:29;
   const q=this.pose([[0,this.small?-.64/compact:.73,this.small?.57:.46,this.small?90:35],[.28,this.small?-.64/compact:.91,this.small?.57:.43,this.small?90:40],[.465,contactX,contactY,writingAngle],[.875,contactX,contactY,writingAngle],[.98,homeX,homeY,homeAngle],[1,homeX,homeY,homeAngle]],p);
   this.pen.style.transform=`translate(-50%,-100%) translate(${q[0]*h*compact}px,${q[1]*h}px) rotate(${q[2]}deg)`;
   this.applyCamera(p,h,compact);
   this.applyMotionBlur(p,h,compact,cardB,activeStroke);
   this.notes.forEach((el,i)=>{const shown=active===i+1?weight:0;el.style.opacity=shown.toFixed(3);el.style.visibility=shown>.001?'visible':'hidden';});

  }
 });
}
